import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { errMsg } from "@/lib/errors";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [status, setStatus] = useState("pending");
  const [msg, setMsg] = useState("");

  useEffect(() => {
    if (!token) { setStatus("error"); setMsg("No token in URL"); return; }
    api.post("/auth/verify-email", { token })
      .then(() => setStatus("ok"))
      .catch((e) => { setStatus("error"); setMsg(errMsg(e)); });
  }, [token]);

  return (
    <div className="min-h-[calc(100vh-4rem)] grid place-items-center px-4">
      <div className="border border-[#2A2A2A] bg-[#121212] p-10 max-w-md w-full text-center">
        {status === "pending" && (<>
          <Loader2 className="h-12 w-12 text-[#FF4500] mx-auto mb-4 animate-spin" />
          <div className="font-display text-2xl">Verifying...</div>
        </>)}
        {status === "ok" && (<>
          <CheckCircle2 className="h-12 w-12 text-[#FF4500] mx-auto mb-4" />
          <div className="font-display text-3xl">Email verified</div>
          <div className="font-mono text-xs text-gray-400 mt-2 uppercase tracking-widest">All features unlocked</div>
          <Link to="/dashboard"><Button data-testid="ve-continue" className="mt-6 rounded-none bg-[#FF4500] text-black font-mono text-xs uppercase">Continue to studio</Button></Link>
        </>)}
        {status === "error" && (<>
          <XCircle className="h-12 w-12 text-yellow-500 mx-auto mb-4" />
          <div className="font-display text-2xl">Couldn't verify</div>
          <div className="font-mono text-xs text-gray-400 mt-2">{msg}</div>
          <Link to="/login"><Button className="mt-6 rounded-none bg-[#FF4500] text-black font-mono text-xs uppercase">Back to sign in</Button></Link>
        </>)}
      </div>
    </div>
  );
}
